import icons from './icons.json'
import { dialogLabels } from './zencare'

export const travel: BenefitStoreContext[string] = {
	short_description: 'Our travel Insurance plan gives you 360° coverage when you travel outside the country.',
	description:
		'Travel covers any unforeseen circumstances that may arise on your trip. This only covers international travels.',
	product_title: 'Get covered against any unforeseen circumstances during your international business travel.',
	card_label:
		'Protection for medical issues, evacuation, and trip delays abroad, with coverage based on travel length and destination.',
	dialogLabels,
	short_benefits: {
		'Need To Know': {
			icon: icons.need_to_know,
			isOpen: true,
			value: [
				'The policy excess for emergency medical and associated expenses for Schengen visas is EUR250.',
				'The policy excess for emergency medical and associated expenses for non-Schengen visas is EUR200.',
				'This cover is for persons up to 80 years.',
				'Your premium is determined based on the location and age of the policyholder.'
			]
		},
		'Your Business Will Enjoy': {
			isOpen: false,
			icon: icons.business,
			value: [
				'Covers for medical expense services.',
				'Accommodation costs related to COVID-19.',
				'Compensation for missed Departure / missed Connection.',
				'Protection for repatriation of mortal remains (corpse).'
			]
		},
		'How to get covered': {
			icon: icons.get_covered_icon,
			isOpen: false,
			value: [
				'Purchase a travel insurance policy.',
				'Submit all necessary information and documents.',
				'Activate your policy with your travel details, and receive your insurance certificate.'
			]
		},
		'How to claim': {
			icon: icons.claim,
			isOpen: false,
			value: [
				'Report your claim, with details of the incident.',
				'Submit all necessary information and documents.',
				'Receive and accept your claim offer once your claim is approved.'
			]
		}
	},
	allBenefits: {
		dialog: {
			benefits: [
				'Covers for medical expense services.',
				'Accommodation costs related to COVID-19.',
				'Compensation for missed Departure / missed Connection.',
				'Protection for repatriation of mortal remains (corpse).'
			],
			need_to_know: [
				'The policy excess for emergency medical and associated expenses for Schengen visas is EUR250.',
				'The policy excess for emergency medical and associated expenses for non-Schengen visas is EUR200.',
				'This cover is for persons up to 80 years.',
				'Your premium is determined based on the location and age of the policyholder.'
			],
			'How to get covered': [
				'Purchase a travel insurance policy.',
				'Submit all necessary information and documents.',
				'Activate your policy with your travel details, and receive your insurance certificate.'
			],
			'How to claim': [
				'Report your claim, with details of the incident.',
				'Submit all necessary information and documents.',
				'Receive and accept your claim offer once your claim is approved.'
			]
		}
	}
}
export const aiico_travel_cover = {
	...travel,
	card_label:
		'Coverage for medical emergencies, evacuation, and trip delays abroad, tailored to travel duration and destination.'
}
